import moment from 'moment'

export const defaultStartDate = moment().startOf('day').subtract(2, 'month').toDate()
export const defaultEndDate = moment().endOf('day').toDate()
export const defaultToday = moment().endOf('day').toDate()
